/* Zenitsu tire pour recharger, Inosuke pousse la page, Boutique Demon Slayer (27 et 28/10/2026).
   Charge par snippets/ds-zenitsu.liquid (asset ds-zenitsu.js, defer).
   Mobile : en haut de la page, le doigt qui tire vers le bas fait glisser la
   page et decouvre le bandeau ; passe le seuil, Zenitsu attaque et la page se
   recharge. En bas de la page, meme geste vers le haut : Inosuke pousse la
   page, et passe le seuil il force d'un coup, sans rechargement.
   Ordinateur : la molette ou le trackpad qui insiste en haut ou en bas de la
   page charge le bandeau, puis l'attaque part. Jamais de rechargement.
   Rien ne se declenche quand un tiroir, une fenetre ou le clavier est ouvert,
   ni dans l'editeur de theme. Sans ce script, les bandeaux restent caches. */
(function () {
  'use strict';
  var haut = document.querySelector('[data-ds-zen="haut"]');
  var bas = document.querySelector('[data-ds-zen="bas"]');
  if (!haut || !bas) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var doc = document.documentElement;
  var SEUIL_DOIGT = 96;     /* px de tirage amorti avant l'attaque, au doigt */
  var AMORTI = 0.55;        /* le bandeau suit le doigt a 55 % */
  var SEUIL_ROUE = 640;     /* deltaY cumule a la molette ou au trackpad */
  var REPOS_ROUE = 240;     /* ms sans molette : la charge retombe */
  var DUREE_ATTAQUE = 620;  /* ms, duree de l'animation ds-zen-ruee */
  var RECHARGE_A = 520;     /* ms apres le depart de la ruee : la page se recharge */
  var PAUSE = 1400;         /* ms entre deux attaques */

  haut.hidden = false;
  bas.hidden = false;
  doc.classList.add('ds-zen-actif');

  /* Les blocs de premier niveau dans le flux : ce sont eux qui glissent pour
     decouvrir le bandeau. Les elements fixes (tiroirs, fenetres, boutons
     flottants, chat) et les sections vides restent en place. */
  Array.prototype.forEach.call(document.body.children, function (el) {
    if (el.classList.contains('ds-zen')) return;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.position === 'fixed' || cs.position === 'absolute') return;
    if (!el.getBoundingClientRect().height) return;
    el.classList.add('ds-zen-page');
  });

  var occupe = false;   /* une attaque est en cours ou vient de finir */
  var decalMinuteur = null;

  function bloque() {
    var b = document.body.classList;
    if (b.contains('overflow-hidden') || b.contains('overflow-hidden-mobile') ||
        b.contains('overflow-hidden-tablet') || b.contains('overflow-hidden-desktop')) return true;
    if (document.querySelector('dialog[open], modal-dialog[open], product-modal[open], ' +
        'quick-add-modal[open], details.menu-drawer-container[open], details-modal details[open]')) return true;
    /* la fenetre promo du theme (inscription, compte a rebours) se montre par visibility et opacity */
    var popups = document.querySelectorAll('.popup-modal');
    for (var i = 0; i < popups.length; i++) {
      var cs = getComputedStyle(popups[i]);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0') return true;
    }
    var a = document.activeElement;
    if (a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable)) return true;
    return false;
  }
  function defilement() { return window.scrollY || window.pageYOffset || 0; }
  function enHaut() { return defilement() <= 0; }
  function enBas() { return window.innerHeight + defilement() >= doc.scrollHeight - 2; }

  /* La hauteur utile d'un bandeau est --ds-zen-h : celui du bas mesure 16 px de
     plus, une reserve pour la secousse d'Inosuke, qui ne compte pas ici. */
  function hauteur(b) {
    return parseFloat(getComputedStyle(b).getPropertyValue('--ds-zen-h')) || b.offsetHeight;
  }

  /* p : la charge du bandeau. La page glisse d'autant, vers le bas en haut de
     page, vers le haut en bas de page, et revient en place a zero. */
  function poser(b, p) {
    b.style.setProperty('--ds-zen-p', p.toFixed(3));
    b.classList.toggle('ds-zen--pret', p >= 0.97);
    clearTimeout(decalMinuteur);
    if (p > 0) {
      doc.classList.add('ds-zen-decale');
      doc.style.setProperty('--ds-zen-decal', ((b === haut ? 1 : -1) * p * hauteur(b)).toFixed(1) + 'px');
    } else {
      doc.style.setProperty('--ds-zen-decal', '0px');
      /* on laisse la page revenir en place avant de retirer la transformation */
      decalMinuteur = setTimeout(function () { doc.classList.remove('ds-zen-decale', 'ds-zen-doigt'); }, 260);
    }
  }
  function relacher(b) {
    b.classList.remove('ds-zen--arme', 'ds-zen--tire', 'ds-zen--pret');
    poser(b, 0);
  }

  function attaquer(b, recharger) {
    occupe = true;
    b.classList.remove('ds-zen--arme', 'ds-zen--tire');
    poser(b, 1);
    b.classList.add('ds-zen--attaque');
    if (b === bas) doc.classList.add('ds-zen-pousse');   /* la page tressaute sous la poussee d'Inosuke */
    function fini() {
      b.classList.remove('ds-zen--attaque', 'ds-zen--charge', 'ds-zen--pret');
      doc.classList.remove('ds-zen-pousse');
      poser(b, 0);
      setTimeout(function () { occupe = false; }, PAUSE);
    }
    if (recharger) {
      b.classList.add('ds-zen--charge');
      setTimeout(function () { window.location.reload(); }, RECHARGE_A);
      setTimeout(fini, 5000);   /* si le rechargement n'aboutit pas (hors ligne), on libere */
    } else {
      setTimeout(fini, DUREE_ATTAQUE);
    }
  }

  /* Au doigt. Le premier mouvement decide : vers l'exterieur de la page, le geste
     est a nous et le navigateur ne bouge plus ; sinon il defile comme d'habitude. */
  var doigt = null;
  document.addEventListener('touchstart', function (e) {
    doigt = null;
    if (occupe || e.touches.length !== 1 || bloque()) return;
    var cible = enHaut() ? haut : enBas() ? bas : null;
    if (!cible) return;
    /* Pas d'exclusion des carrousels : sur mobile, la galerie produit occupe tout
       le haut de la page. Un balayage horizontal leur est laisse au premier
       mouvement (ci-dessous), seul le tirage vertical est pris. */
    var t = e.target;
    if (t.closest && t.closest('input, textarea, select, [data-ds-zen-ignorer]')) return;
    doigt = { x: e.touches[0].clientX, y: e.touches[0].clientY, cible: cible, p: 0, actif: false, decide: false };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!doigt) return;
    var t = e.touches[0];
    var dx = t.clientX - doigt.x;
    var dy = t.clientY - doigt.y;
    var tirage = doigt.cible === haut ? dy : -dy;   /* positif : on tire hors de la page */
    if (!doigt.decide) {
      doigt.decide = true;
      if (Math.abs(dx) > Math.abs(dy) || tirage <= 0) { doigt = null; return; }
      doigt.actif = true;
      doigt.cible.classList.add('ds-zen--arme', 'ds-zen--tire');
      doc.classList.add('ds-zen-doigt');
    }
    if (!e.cancelable) { relacher(doigt.cible); doigt = null; return; }
    e.preventDefault();
    doigt.p = Math.min(1, Math.max(0, tirage * AMORTI / SEUIL_DOIGT));
    poser(doigt.cible, doigt.p);
  }, { passive: false });

  function finDoigt() {
    if (!doigt) return;
    var d = doigt;
    doigt = null;
    if (!d.actif) return;
    doc.classList.remove('ds-zen-doigt');   /* la page revient en place en glissant */
    if (d.p >= 1) attaquer(d.cible, d.cible === haut);
    else relacher(d.cible);
  }
  document.addEventListener('touchend', finDoigt, { passive: true });
  document.addEventListener('touchcancel', finDoigt, { passive: true });

  /* A la molette ou au trackpad. La charge s'accumule tant qu'on insiste contre
     le bord ; elle retombe des que la molette se tait. */
  var charge = 0;
  var cibleRoue = null;
  var minuteur = null;
  function retomber() {
    clearTimeout(minuteur);
    if (cibleRoue) relacher(cibleRoue);
    cibleRoue = null;
    charge = 0;
  }
  window.addEventListener('wheel', function (e) {
    if (occupe || bloque()) return;
    var dy = e.deltaY * (e.deltaMode === 1 ? 40 : e.deltaMode === 2 ? window.innerHeight : 1);
    var cible = dy < 0 && enHaut() ? haut : dy > 0 && enBas() ? bas : null;
    if (!cible || (cibleRoue && cible !== cibleRoue)) { retomber(); return; }
    if (!cibleRoue) cible.classList.add('ds-zen--arme');
    cibleRoue = cible;
    charge += Math.abs(dy);
    clearTimeout(minuteur);
    if (charge >= SEUIL_ROUE) {
      cibleRoue = null;
      charge = 0;
      attaquer(cible, false);
      return;
    }
    poser(cible, charge / SEUIL_ROUE);
    minuteur = setTimeout(retomber, REPOS_ROUE);
  }, { passive: true });
})();
